const facetsState = [];

let totalResults = 0;
let isFacetToggleActive = false;

// Function to toggle sorting of results based on option in .clerk-search-sorting.
// The function takes the value of the option and splits it by |.
// The value should always be either asc or desc followed by | and the attribute key.
// The only exception to this is the default sorting which is defined as null_null.
const sortResultsByOption = (val) => {
	Clerk('content', '.clerk', 'param', {
		order: parseSortingValue(val.split('|')[0]),
		orderby: parseSortingValue(val.split('|')[1])
	});
}

const parseSortingValue = (value) => {
	return value === 'null' ? null : value;
}

const attachResultsSorting = () => {
	document.querySelectorAll('.clerk-search-sorting').forEach((element) => {
		element.addEventListener('change', (event) => {
			sortResultsByOption(event.currentTarget.options[event.currentTarget.selectedIndex].value, event);
		});
		element.dispatchEvent(new Event('change'));
	});
}

// Workarounds for instant search issues.
// These need to be reported to Clerk and solved by them.
const closeInstantSearch = () => {
	document.querySelectorAll('.search-field').forEach((element) => {
		// Hide empty results when search term is found and then removed fast or X icon clicked.
		['keyup', 'search'].forEach(evt => {
			element.addEventListener(evt, (event) => {
				if (!event.target.value.length) {
					document.getElementById('instant-search').style.display = 'none';
				}
			});
		});

		// Hide on focus out.
		element.addEventListener('blur', (event) => {
			const instantSearch = document.getElementById('instant-search');
			// Check if user hasn't clicked a link inside instant search container.
			if ( event.relatedTarget === null || ! instantSearch.contains(event.relatedTarget) ) {
				instantSearch.style.display = 'none';
			}
		});

		// Show on focus.
		element.addEventListener('focus', (event) => {
			if (event.target.value.length > 1) {
				document.getElementById('instant-search').style.display = 'block';
			}
		});
	});
}

const activateFacetsToggle = () => {
	const facetsToggles = document.querySelectorAll('.clerk-search-filters-button');

	facetsToggles.forEach((element) => {
		element.classList.remove('clerk-hidden');

		// Show or hide facets on button click.
		element.addEventListener('click', () => {
			facets = document.querySelector('#clerk-search-filters');

			if (facets) {
				document.body.classList.toggle('clerk-filter-open');
				facets.classList.toggle('clerk-slide-in');
				facets.classList.toggle('clerk-slide-out');
			}
		});
	});
}

const toggleSearchResults = (content, data) => {
	const clerkContainer = document.querySelector('.clerk-container');

	if (!clerkContainer || data.status === 'error') {
		return;
	}

	totalResults += data.result.length;

	if (totalResults > 0) {
		clerkContainer.classList.remove('clerk-empty-results');
		return;
	}

	clerkContainer.classList.add('clerk-empty-results');
}

const saveFacetsState = () => {
	document.querySelectorAll('#clerk-search-filters details').forEach((element) => {
		const group = element.getAttribute('data-facet-group');
		const open = element.getAttribute('open');
		facetsState[group] = open !== null ? true : false;
	});
}

const updateFacetsState = () => {
	document.querySelectorAll('#clerk-search-filters details').forEach((element) => {
		const group = element.getAttribute('data-facet-group');
		if (facetsState[group] !== undefined && facetsState[group] === true) {
			element.setAttribute('open', '');
		}
	});
}

const closeFacets = () => {
	document.querySelectorAll('.clerk-facet-close').forEach((element) => {
		element.addEventListener('click', () => {
			button = document.querySelector('#clerk-search-filters');

			if (button) {
				document.body.classList.remove('clerk-filter-open');
				button.classList.remove('clerk-slide-in');
				button.classList.add('clerk-slide-out');
			}
		});
	});
}

const getActiveFacets = () => {
	return document.querySelectorAll('.clerk-facet-selected');
}

const resetFacets = () => {
	const facetReset = document.querySelector('.clerk-facet-reset');

	if (!facetReset) {
		return;
	}

	const activeFacets = getActiveFacets();

	if (!activeFacets.length) {
		return;
	}

	facetReset.parentElement.classList.remove('clerk-hidden');

	facetReset.addEventListener('click', () => {
		activeFacets.forEach((element) => {
			const elementContainer = element.closest('.clerk-facet-group');
			const elementContainerStyles = window.getComputedStyle(elementContainer);
			if (elementContainerStyles.display === 'none') {
				return;
			}
			element.click();
		});
	});
}

const createActiveFilterButton = (element) => {
	const dataFacet = element.getAttribute('data-facet');
	const dataValue = element.getAttribute('data-value');
	const value = element.querySelector('.clerk-facet-name').textContent || dataValue;

	const button = document.createElement('button');
	button.classList.add('clerk-facet-button');
	button.setAttribute('data-facet', dataFacet);
	button.setAttribute('data-value', dataValue);

	button.addEventListener('click', () => {
		element.click();
	});

	const textnode = document.createTextNode(value);
	button.appendChild(textnode);

	return button;
}

const updateActiveFacetsArea = () => {
	const facetsArea = document.querySelector('#clerk-active-filters-area');

	if (!facetsArea) {
		return;
	}

	facetsArea.innerHTML = '';

	const activeFacets = getActiveFacets();

	activeFacets.forEach((element) => {
		facetsArea.appendChild(createActiveFilterButton(element));
	});
}

const setMoreContentButton = () => {
	document.querySelectorAll('.clerk-more-content-button').forEach((element) => {
		const contentId = element.getAttribute('data-more-content-id');
		element.addEventListener('click', () => {
			Clerk('content', '#' + contentId, 'more', 20);
		});
	});
}

const toggleInstantSearch = (content, data) => {
	if (content.id !== 'instant-search') {
		return;
	}

	document.getElementById('instant-search').style.display = data.result.length ? 'block' : 'none';
}

const runOnRendered = (content, data) => {
	setMoreContentButton();

	// Do not show facet pop-up and facet button if no facets are returned.
	if (!data.facets || !Object.entries(data.facets).length) {
		return;
	}

	// Attach event only once.
	if (!isFacetToggleActive) {
		activateFacetsToggle();
		isFacetToggleActive = true;
	}

	updateFacetsState();
	closeFacets();
	resetFacets();
	updateActiveFacetsArea();
}

document.addEventListener('DOMContentLoaded', () => {
	if (typeof Clerk === 'undefined') {
		return;
	}

	closeInstantSearch();

	Clerk('on', 'response', toggleInstantSearch);

	// Run only on archive pages (shop, catalog, search).
	if (!document.querySelector('body.archive')) {
		return;
	}

	attachResultsSorting();

	Clerk('on', 'update', saveFacetsState);
	Clerk('on', 'response', toggleSearchResults);
	Clerk('on', 'rendered', runOnRendered);
});
